import Marquee from "react-fast-marquee";

const items = [
  "Answers every call",
  "Straight into your POS",
  "Never miss an order",
  "Open 24/7",
  "Free up your team",
  "Every guest welcomed",
  "No more busy signals",
  "Ready for the kitchen",
];

const Dot = () => <span className="mx-6 md:mx-10 text-terra text-2xl leading-none">✦</span>;

const EditorialMarquee = () => {
  return (
    <section className="border-y border-line bg-surface py-6 md:py-8" data-testid="marquee-section">
      <Marquee speed={40} gradient gradientColor="#1A1816" gradientWidth={80} autoFill>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading text-2xl md:text-4xl font-medium tracking-tight text-cream/90">
              {item}
            </span>
            <Dot />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
